<template>
  <footer class="page-footer">
    <p class="page-footer__text">
      Need help or found a bug?
      <a href="https://github.com/MorayM/sample-tools" target="_blank">
        Report it on GitHub
      </a>
    </p>
    <p class="page-footer__text">
      Made with 🔴 by Moray Macdonald aka <a href="https://cephid.world/" target="_blank">Cephid</a> 🎶
    </p>
  </footer>
</template>

<style>
.page-footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
}

.page-footer__text {
  color: #6b7280;
  font-size: 0.95rem;
  margin: 0;
}

.page-footer__text a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.page-footer__text a:hover {
  color: #5a67d8;
  text-decoration: underline;
}
</style>